const cookieBox = document.querySelector('.cookie-popup');
const buttons = document.querySelectorAll('.button');

const executeCookiesPopup = () => {
    if (document.cookie.includes('cookies_policy=accepted')) return;
    cookieBox.classList.add('show');

    buttons.forEach((button) => {
        button.addEventListener('click', () => {
            cookieBox.classList.remove('show');

            if (button.id == 'acceptBtn') {
                //set cookies for 1 month. 60 = 1 min, 60 = 1 hours, 24 = 1 day, 30 = 30 days
                document.cookie = 'cookies_policy=accepted; max-age=' + 60 * 60 * 24 * 30;
            }
        });
    });
};

window.addEventListener('load', executeCookiesPopup);

